// Variable Declaration
const $tabSelects = $('#js-tab-select');
const $tabs = $('a[data-toggle="tab"]');
const activeTab = window.sandals_app.page.activeTab;

const callingCodesObj = require('~/js/modules/countryCallingCodes');

// Select handler
const selectHandler = (event, ui) => {
    // console.log(ui.item);
    const { index, value } = ui.item;

    if (value === '/sign-up/') {
        window.location = value;
    }

    $($tabs[index]).tab('show');
};

$tabs.on('click', event => {
    const element = $(event.currentTarget);

    history.pushState('', '', `?tab=${element.data('param')}`);
});

if (window.location.hash === '#worldwide/') {
    $($tabs[2]).tab('show');
}

// Initialization selectmenu
$tabSelects.val(activeTab);
$tabSelects.selectmenu({
    appendTo: $tabSelects.parent(),
    select: selectHandler
});

// create new array for countries and appending a new object that represents default value
const countries = [
    {
        country: 'Select Your Country',
        countryId: '',
        regionCode: '',
        countryCode: ''
    },
    ...window.sandals_app.page.countries
];

// create new array for states and appending a new object that represents default value
const states = [...window.sandals_app.page.states];

const sandalsResorts = window.sandals_app.page.resorts;

// react form elements contact
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomDatepicker from '~/js/components/form-controls/CustomDatepicker';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import CustomTextarea from '~/js/components/form-controls/CustomTextarea';
import DepartmentSelect from '~/js/components/DepartmentSelect';

ReactDOM.render(
    <CountryStateSelector
        countries={countries}
        states={states}
        countryName="country"
        stateName="state"
        stateLabelWrapper="col-sm-4"
        stateInputWrapper="col-sm-8"
        countryLabelWrapper="col-sm-4"
        countryInputWrapper="col-sm-8"
    />,
    document.getElementById('country-state-selector')
);

ReactDOM.render(
    <CustomDatepicker
        name="weddingDate"
        wrapperClassName="col-xs-12 col-sm-8"
        inputClassName="hidden-validation wedding-date-input"
        isRequired
    />,
    document.getElementById('wedding-datepicker')
);

ReactDOM.render(
    <CustomTextarea
        name="message"
        id="message"
        maxLength="4000"
        displayCharacterCount
        isRequired
    />,
    document.getElementById('react-textarea')
);

ReactDOM.render(
    <CustomRecaptcha wrapperClassName="col-xs-12 col-sm-6 col-sm-offset-3" />,
    document.getElementById('google-recaptcha')
);

ReactDOM.render(
    <DepartmentSelect resorts={sandalsResorts} />,
    document.getElementById('department-dropdown')
);

// form validations
import '~/js/modules/fend';

// Form Validation
const $formFend = $('.contact-form').fend({
    rules: {
        firstName: 'lettersOnly',
        lastName: 'lettersOnly',
        contactNumber: 'alphanumeric',
        minlength: 7
    }
});

// form elements references
const $weddingDateRow = $('.wedding-date-row');
const $weddingDateInput = $('.wedding-date-input');
/* const $countrySelector = $('select[name="country"]');
const $subscribeLabel = $('.form-label[for="subscribe"]');

$subscribeLabel.text($subscribeLabel.data('normal'));

$countrySelector.on('change', (event) => {
    const countryId = event.target.value;

    $subscribeLabel.text($subscribeLabel.data('normal'));

    if (countryId === 'CA') {
        $subscribeLabel.html($subscribeLabel.data('canada'));
    }
});
*/

const $countrySelector = $('select[name="country"]');
const $subscribeLabel = $('.form-label[for="subscribe"]');
const $landlineNumber = $('#landLineNumber');
const $mobileNumber = $('#mobileNumber');
const $wantToBeCalledDropdown = $('#wantToBeCalledDropdown');

$subscribeLabel.text($subscribeLabel.data('normal'));

$countrySelector.on('change', event => {
    const countryId = event.target.value;

    $subscribeLabel.text($subscribeLabel.data('normal'));

    if (countryId === 'CA') {
        $subscribeLabel.html($subscribeLabel.data('canada'));
        $('.contact-form__descr').hide();
    } else {
        $('.contact-form__descr').show();
    }
});

// display wedding date
$('[name="planningWedding"]').on('change', event => {
    const $selectedValue = event.target.value;

    if ($selectedValue === 'true') {
        $weddingDateRow.slideDown('fast');
        $weddingDateInput.removeClass('hidden-validation');
    } else {
        $weddingDateRow.slideUp('fast');
        $weddingDateInput.addClass('hidden-validation');
    }

    $formFend.form();
});

$(document).ready(() => {
    $landlineNumber.change = () => {
        if ($landlineNumber.val()) {
            $mobileNumber.removeAttr('required');
            $mobileNumber.trigger('blur');
        }
        if (!$landlineNumber.attr('required')) {
            $landlineNumber.attr('required', true);
            $landlineNumber.trigger('blur');
        }
    };
    $mobileNumber.change = () => {
        if ($mobileNumber.val()) {
            $landlineNumber.removeAttr('required');
            $landlineNumber.trigger('blur');
        }
        if (!$mobileNumber.attr('required')) {
            $mobileNumber.attr('required', true);
            $landlineNumber.trigger('blur');
        }
    };
    if ($landlineNumber.val()) {
        $mobileNumber.removeAttr('required');
        $mobileNumber.trigger('blur');
    }
    if ($mobileNumber.val()) {
        $landlineNumber.removeAttr('required');
        $landlineNumber.trigger('blur');
    }
    // FOR COUNTRY CODE
    $('[name=country]').on('change', () => {
        const selectedCountry = $(this).val();

        callingCodesObj.countryCodes.map((index) => {
            if (selectedCountry === index.code) {
                $('span.countryCode').html(index.dial_code);
            }
        });
    });
});

// Would you like us to call you drop down activation
$('[name="wantToBeCalled"]').on('change', event => {
    const $selectedValue = event.target.value;

    if ($selectedValue === 'true') {
        $wantToBeCalledDropdown.slideDown('slow');
        document.getElementById('bestTimeToCall').required = true;
        document.getElementById('timezone').required = true;
        document.getElementById('landLineNumber').required = true;
        document.getElementById('mobileNumber').required = true;
    } else {
        $wantToBeCalledDropdown.slideUp('slow');
        document.getElementById('bestTimeToCall').required = false;
        document.getElementById('timezone').required = false;
        document.getElementById('landLineNumber').required = false;
        document.getElementById('mobileNumber').required = false;
    }
});

// requared minimum one phone field
(function requiredPhoneField() {
    const phoneFields = [...document.querySelectorAll('.phone')];

    function testEmptyFields() {
        if (phoneFields.some(phoneField => phoneField.value !== '')) {
            for (const phoneField of phoneFields) {
                phoneField.removeAttribute('required');
                if (phoneField.nextElementSibling) {
                    phoneField.parentNode.removeChild(
                        phoneField.nextElementSibling
                    );
                }
            }
        } else {
            for (const phoneField of phoneFields) {
                phoneField.setAttribute('required', 'required');
            }
        }
    }

    for (const phoneField of phoneFields) {
        phoneField.addEventListener('input', testEmptyFields);
    }

    window.addEventListener('load', testEmptyFields);
})();

// show wedding field if checkbox Yes
(function showWeddingField() {
    const checkBoxYes = document.querySelector('#planningWeddingYes');

    function testChecked() {
        if (checkBoxYes.checked) {
            document.querySelector('.wedding-date-row').style.display = 'block';
        }
    }

    window.addEventListener('load', testChecked);

})();
